import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
      <h2 class="text-center bold">Serio de parodioj</h2>
      <p class="italic text-center">
        en la stilo de famaj rusaj poetoj <br/>
        al infana popola kanteto <br/>
        <span class="bold">«Griza Kapreto»</span>
      </p>

      <p class="text-center italic mb-3 mt-3">
        Kvazaŭ ruĝa fadeno trairas la mondan literaturon korŝira historio pri la griza kapreto. <br/>
        La originalo:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Vivis ĉe olda dam’ griza kapreto, <br/>
          Du-tri, du-tri, griza kapreto. (2 foje)
        </p>

        <p class="poem-block mb-3">
          Amis treege lin kara avino, <br/>
          Du-tri, du-tri, bona avino. (2 foje)
        </p>

        <p class="poem-block mb-3">
          Foje forkuris li al la arbaro, <br/>
          Du-tri, du-tri, nigra arbaro. (2 foje)
        </p>

        <p class="poem-block mb-3">
          Tie formanĝis lin griza luparo, <br/>
          Du-tri, du-tri, kruela luparo. (2 foje)
        </p>

        <p class="poem-block mb-3">
          Kaj restis por la avin’ hufoj kaj kornoj, <br/>
          Jen do, jen do, hufoj kaj kornoj. (2 foje)
        </p>
      </div>
      

      <p class="text-center italic mb-3 mt-3">
        Lia tragika sorto dum longaj jaroj elvokis la inspiron de multaj eminentaj aŭtoroj. <br/>
        Jen kiel rakontus la saman historion rusa ekstravaganta <br/> 
        poeto-modernisto <br/>
        Igor Severjanin:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Oldulin’-sorĉistino <br/>
          Pro la ama inklino <br/>
          Flirtis en reva sento kiel kordo en vent’. <br/>
          Kapro juna kaj griza <br/>
          Kun ĉarmeco Pariza <br/>
          Ludis skercon amoran por animo en tent’.
        </p>

        <p class="poem-block mb-3">
          Sur herbejo aĵura <br/>
          Ortagmezo purpura. <br/>
          Tiel lace-langvore gapas li al arbar’… <br/>
          Kiel bone sen vorto <br/>
          Sin fordoni al sorto <br/>
          Kaj atendi surprizon en silento, sen far’.
        </p>

        <p class="poem-block mb-3">
          Ho, adori la lupon, <br/>
          El si fari la supon <br/>
          Por plenigi la beston per ekstaza pasi’. <br/>
          Kaj al sorĉistulino <br/>
          Kun sinistra inklino <br/>
          Imponante donaci ŝikan kornon de si!
        </p>
      </div>

      
      <p class="text-center italic mb-3 mt-3">
        Kaj jen tute alia poeto, tenera kaj langvora <br/> 
        Aleksandr Vertinskij:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Kien foriris vi, ho griza, ho kapreto, <br/>
          Kun sonoril’ sur kol’, rubando sur la korn’? <br/>
          Sopiras la ĝarden’, kaj ploras virineto <br/>
          Pro la mortinta am’, kaj pro venonta morn’.
        </p>

        <p class="poem-block mb-3">
          En lasta trista hor’ mi vidis vin proksime, <br/>
          Al nigr’arbar’ vi strebis en kabriolet’, <br/>
          Kaj poste falis vi sub lupa pez’ senlime, <br/>
          Lasinte kornojn nur al povra virinet’.
        </p>
      </div>

      
      <p class="text-center italic mb-3 mt-3">
        Jen kruda kaj morne ironia <br/> 
        Saŝa Ĉornij:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Ŝiris harojn pro griza kapraĉ’ oldulino… <br/>
          (Ploru, ploru, formanĝu vin lupoj!). <br/>
          Ŝi lamentis pro sia severa destino <br/>
          Kaj karesis (tfu!) kornajn hufojn.
        </p>

        <p class="poem-block mb-3">
          Kial preterrigardis vi, kap’ sen cerbo? <br/>
          Ja forkuris via trezoro. <br/>
          Kaj kuŝas en arbaro sur herbo <br/>
          Ostoj de kapro, kiu kredis je boneco de lupa moro.
        </p>

        <p class="poem-block mb-3">
          Amegis, fordonis la lastan paneron, <br/>
          Sed lupoj – ne kokinoj! <br/>
          Ili lasis al avino sur sanga tero <br/>
          Nur hufojn kaj kornojn. Jen fino.
        </p>
      </div>

      
      <p class="text-center italic mb-3 mt-3">
        Kaj nun – tri poetoj de la mezo de XXa jarcento. Jen ĉiam aktuala <br/> 
        Eŭgenij Evtuŝenko:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Jen kio en la viv’ okazis: <br/>
          La kapro griza min forlasis, <br/>
          Sed vizitadas min en van’ <br/>
          La vulpo rufa, verda ran’…
        </p>

        <p class="poem-block mb-3">
          La kapro mia kun aliuj <br/>
          Vagadas en arbar’, ne tiuj <br/>
          Kiujn bezonas li en kor’. <br/>
          Ni ambaŭ ploras en la ĥor’.
        </p>

        <p class="poem-block mb-3">
          La lupo per brakum’ tenera <br/>
          Lin logis al arbar’ danĝera, <br/>
          Kaj mi en malespera sent’ <br/>
          Brakumas triste kun serpent’…
        </p>

        <p class="poem-block mb-3">
          Jen restis hufoj nur kaj kornoj <br/>
          De mia am’ en tagoj mornaj. <br/>
          Ho IU, venu por alvok’, <br/>
          Min savu de l’ fremdul’ minaca <br/>
          Kaj kun anim’ de l’ kapro paca <br/>
          Min ligu en beata lok’.
        </p>
      </div>

      
      <p class="text-center italic mb-3 mt-3">
        Jen profundsenta <br/> 
        Andrej Voznesenskij:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          En aŭroro mi vekos la kapron, <br/>
          Li foriros al nigra arbaro, <br/>
          Kaj sopire mi klinos la kapon, - <br/>
          Dio nin ne kunigis en paro.
        </p>

        <p class="poem-block mb-3">
          Mi senŝua al sojlo foriros <br/>
          Lastrigardi al griza, kornhava. <br/>
          «Bonan vojon» al li mi deziros, <br/>
          Kvankam ĉeas jam son’ de malsavo.
        </p>

        <p class="poem-block mb-3">
          Du ĉerizoj enlarme dronitaj – <br/>
          Kuŝas kornoj kaj hufoj sur herbo. <br/>
          Mi sur ter’ vin revidos neniam, <br/>
          Sed pri vi ne forgesos la cerbo!
        </p>
      </div>

      
      <p class="text-center italic mb-3 mt-3">
        Kaj jen patosa <br/> 
        Robert Roĵdestvenskij:
      </p>


      <div class="poem">
        <p class="poem-block mb-3">
          Tio estis. Forgesis – kiam. <br/>
          Nure gravas, ke o-kazis. <br/>
          Kapron oni forŝtelis mian <br/>
          Dum mi propran vizaĝon razis.
        </p>

        <p class="poem-block mb-3">
          Mi animon disŝiris floke, <br/>
          Mi ne kredas al mens’ klara: <br/>
          Al densej’ de l’ arbar’ loka <br/>
          Forlogita kapret’ kara.
        </p>

        <p class="poem-block mb-3">
          Griza lupo, muzel’ turpa, <br/>
          Lin devoris kun ĝu’ mava. <br/>
          Jen ĉi tiel okazis murdo, <br/>
          Ĉar forestis la man’ sava.
        </p>

        <p class="poem-block mb-3">
          Pendas Lun’ kiel lupa dento, <br/>
          En horor’ mi entiras kapon. <br/>
          Ĉu en la trideka jarcento <br/>
          Lupoj ankaŭ mortigos kaprojn?!
        </p>
      </div>
    `
  )
}


const itemName = {
  esp: 'Kozliki'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;